module.exports = __webpack_public_path__ + "static/media/dumbot.ef22df66.png";